import codes from '@/codes'

//restful api
import { detect as integrity } from '@/service/api/integrity'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}
});

const i18n_fields = {
  EN: [
    { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: `Action`, sortable: false, thStyle: 'width: 18%' },
    { key: 'target', label: 'Target', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '시간', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: `행위`, sortable: false, thStyle: 'width: 18%' },
    { key: 'target', label: '대상', sortable: false },
  ]
}

export default {
  props: ['is_main'],
  data : () => {
    return {
      hash_key : null,
      so : default_opt(),
      selected : '',
      codes,
      limit : 15,
      actions : Object.keys(codes.agent_forgery).join(', ')
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    },
  },
  methods: {
    save(item) {
      let snapshot = [[item.target, item.depth, item.hash_selected.value]]
      // Api.Manager({target: 'integrity', cmd : 'update', body : { id : item.forgery_id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id }})
      integrity.updateDetect({ id : item.forgery_id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id })

    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('WSFinder', 'refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [{ name : "type", value : "wsfinder", op : "="}] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='}, { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return integrity.listDetect(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) );
    },
    detail(item) { this.$router.push(`domain/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('WSFinder', 'integrity.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created() { console.log('WSFinder', 'integrity.vue', 'created'); },
  destroyed() { console.log('WSFinder', 'integrity.vue', 'destroyed'); },
  mounted() { console.log('WSFinder', 'integrity.vue', 'mounted'); },
}